import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'bootstrap';
import OtpInput from 'react-otp-input';

const VerificationCodeModal = ({ show, onCheck, onNext, onCancel }: Props) => {
  const [code, setCode] = useState('');
  const [valid, setValid] = useState(false);
  const [checked, setChecked] = useState(false);
  const modalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    modalRef.current && new Modal(modalRef.current, { backdrop: 'static' });
    return () => {
      modalRef.current && Modal.getInstance(modalRef.current)?.dispose();
    }
  }, []);

  useEffect(() => {
    setCode('');
    setChecked(false);
    setValid(false);
    if(modalRef.current) {
      const instance = Modal.getInstance(modalRef.current);
      if(instance) {
        show ? instance.show() : instance.hide();
      }
    }
  }, [ show ]);

  const onChange = async (code: string) => {
    setCode(code.toUpperCase());
    if(code.length === 6) {
      const valid = await onCheck(code.toUpperCase());
      setValid(valid);
      setChecked(true);
    }
  }

  return (
    <div ref={modalRef} className="modal fade" data-bs-backdrop="static" tabIndex={-1}>
        <div className="modal-dialog modal-sm">
          <div className="modal-content bg-white">
            <div className="modal-header">
              <h3 className="modal-title w-100 text-center">Enter Your Verification Code</h3>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onCancel}></button>
            </div>
            <div className="modal-body">
              <p className="mb-4 text-center"><small>Paste below the verification code you received in your inbox.</small></p>
              <p className="mb-4 text-center"><small>Once verified you can change the email</small></p>
              <div className="mb-4">
                <OtpInput containerStyle={{ justifyContent: 'space-between'}} inputStyle={{ width: 40 }} value={code} onChange={onChange} numInputs={6} renderInput={(props) => <input {...props} className={`form-control form-control-lg text-center text-capitalize p-1 ${checked && (valid ? 'border-success' : 'border-danger')}`} />} />
                {checked &&
                  <div className="w-100 text-end">
                    <small className={`text-${valid ? 'success' : 'danger'}`}>{valid ? 'Activation code is valid' : 'Code not recognized — please check and try again'}</small>
                  </div>
                }
              </div>
              <p className="text-center"><small>Make sure your Vision Node is online before starting the activation. <br />Need help? Contact support@broox.io.</small></p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary m-0 w-100" data-bs-dismiss="modal" disabled={!valid} onClick={() => onNext(code)}>Next</button>
              <button type="button" className="btn bg-gray-02 m-0 mt-3 w-100" data-bs-dismiss="modal" onClick={onCancel}>Cancel</button>
            </div>
          </div>
        </div>
      </div>
  );
}

interface Props {
  show: boolean,
  onCheck: (code: string) => Promise<boolean>,
  onNext: (code: string) => void,
  onCancel: () => void
}

export { VerificationCodeModal };